import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {forkJoin, Observable, of} from 'rxjs';
import {User} from '../models/users/user.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) {
  }

  private USERS_URL: string = environment.BASE_URL + 'user';

  public getUsers(): Observable<Array<User>> {
    return this.http.get<Array<User>>(this.USERS_URL).pipe(
    );
  }

  public getUser(id: string): Observable<User> {
    return this.http.get<User>(`${this.USERS_URL}/${id}`).pipe(
    );
  }

  public createUser(user: User): Observable<User> {
    return this.http.post<User>(`${this.USERS_URL}`, user).pipe(
    );
  }

  public updateUser(user: User): Observable<User> {
    return this.http.patch<User>(`${this.USERS_URL}/${user.id}`, user).pipe(
    );
  }

  public deleteUser(user: User): Observable<User> {
    return this.http.delete<User>(`${this.USERS_URL}/${user.id}`).pipe(
    );
  }
}
